export const getWhatsAppNumber = (raw: string): string => {
  const digits = raw.replace(/\D/g, "");
  if (raw.trim().startsWith("+") || digits.length > 10) return digits;
  if (digits.length === 10) return `91${digits}`;
  return digits;
};
